export enum FeatureGitWorkerAction {
  HydrateStores = 'fs-hydrate-stores',
  ReadGitStoreModel = 'fs-read-git-store-model',
  ReadGitStoreModels = 'fs-read-git-store-models',
  ReadStoreModel = 'fs-read-store-model',
}
